import React from "react";
import { Link } from "@/components/common/Link";
import { Tractor, Waves, Crown, Leaf, Warehouse, Heart, Building2, House, Map, Compass, ChevronRight, Star } from "lucide-react";
const cities = [{
  name: "תל אביב",
  desc: "שירות מהיר במרכז העיר",
  icon: Building2,
  path: "/NursingCaregiverInTelAvivWithinFiveHoursPage"
}, {
  name: "חיפה",
  desc: "מענה סיעודי לתושבי הצפון",
  icon: Waves,
  path: "/NursingCareProviderInHaifaWithinHoursPage"
}, {
  name: "ירושלים",
  desc: "טיפול מסור בבירה",
  icon: Crown,
  path: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
}, {
  name: "ראשון לציון",
  desc: "ליווי אישי בלב העיר",
  icon: Heart,
  path: "/NursingCaregiverInRishonLeZionWithinFiveHoursPage"
}, {
  name: "פתח תקווה",
  desc: "סיוע מקצועי למשפחות",
  icon: House,
  path: "/NursingCareProviderPetahTikvaWithinHoursPage"
}, {
  name: "רמת גן",
  desc: "טיפול איכותי וקרוב",
  icon: Building2,
  path: "/NursingCaregiverInRamatGanWithinHoursPage"
}, {
  name: "מודיעין",
  desc: "שירותי סיעוד מתקדמים",
  icon: Map,
  path: "/NursingCaregiverInModiinWithinFiveHoursPage"
}, {
  name: "הרצליה",
  desc: "טיפול VIP בבית הלקוח",
  icon: Star,
  path: "/NursingCareProviderInHerzliyaWithinFiveHoursPage"
}, {
  name: "נתניה",
  desc: "זמינות גבוהה בשרון",
  icon: Compass,
  path: "/SeoPagesForNursingCareProviderInJerusalemHaifaPetahTikvaAndNetanyaPage"
}, {
  name: "באר שבע",
  desc: "מעטפת סיעודית בדרום",
  icon: Leaf,
  path: "#"
}, {
  name: "חולון",
  desc: "ליווי יומיומי צמוד",
  icon: House,
  path: "#"
}, {
  name: "אשדוד",
  desc: "שירות מקצועי לקהילה",
  icon: Waves,
  path: "#"
}];
const stats = [{
  value: "12",
  label: "ערים מרכזיות בפריסה ארצית"
}, {
  value: "10,000+",
  label: "משפחות שקיבלו מענה סיעודי"
}, {
  value: "4.9",
  label: "דירוג שביעות רצון לקוחות",
  hasStar: true
}];
export default function DetailedServiceList() {
  return <section data-section-id="257350" id="שירותים-סיעודיים" className="py-20 bg-background text-foreground">
      <div className="page-container">
        {}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="text-primary font-default font-semibold text-sm uppercase tracking-wider mb-4">
            פריסה ארצית רחבה לשירותכם
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-6">
            שירותי מטפל סיעודי ב-12 ערים מרכזיות
          </h2>
          <p className="text-muted-foreground font-default text-lg">
            אנו מספקים את המענה המהיר ביותר בישראל עבור{" "}
            <strong className="text-foreground font-semibold">
              מטפל סיעודי פרטי
            </strong>{" "}
            וכן{" "}
            <strong className="text-foreground font-semibold">
              ליווי סיעודי מקצועי
            </strong>{" "}
            בבית הלקוח. מתל אביב ועד חיפה, פתרון מיידי תוך 5 שעות בלבד.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {cities.map((city, i) => {
          const Icon = city.icon;
          return <Link key={city.name} to={city.path} data-index={i} className="flex items-center p-4 rounded-lg bg-card hover:bg-accent transition-colors border border-border shadow-sm group">
                <div className="w-10 h-10 rounded-md bg-muted flex items-center justify-center text-foreground/70 mr-4 shrink-0 group-hover:text-primary group-hover:bg-primary/10 transition-colors">
                  <Icon size={20} strokeWidth={1.5} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-default font-semibold text-foreground text-sm truncate">
                    {city.name}
                  </h3>
                  <p className="text-xs text-muted-foreground font-default truncate">
                    {city.desc}
                  </p>
                </div>
                <ChevronRight className="w-4 h-4 text-muted-foreground/50 group-hover:text-primary transition-colors shrink-0 ml-2" />
              </Link>;
        })}
        </div>

        {}
        <div className="bg-card rounded-lg p-8 md:p-12 flex flex-col md:flex-row justify-around items-center gap-8 border border-border shadow-md">
          {stats.map((stat, i) => <div key={i} data-index={i} className="text-center flex-1">
              <div className="text-4xl md:text-5xl font-default font-bold text-foreground mb-2 flex items-center justify-center gap-1">
                {stat.value}
                {stat.hasStar && <Star className="w-8 h-8 fill-primary text-primary" />}
              </div>
              <p className="text-sm text-muted-foreground font-default max-w-[200px] mx-auto">
                {stat.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}